import { styled } from '@mui/material/styles';
// @ts-ignore - Temporary workaround for TypeScript import issue
import { DataGrid } from '@mui/x-data-grid';
import { Colors } from '../../styles/colors';

export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    '--unstable_DataGrid-radius': '14px !important',
    '--DataGrid-containerBackground': 'transparent !important',
    '--DataGrid-pinnedBackground': 'transparent !important',
    '--DataGrid-rowBorderColor': 'transparent !important',

    border: '1px solid #E0E2F1 !important',
    borderRadius: '14px !important',

    overflow: 'hidden',
    '& .MuiDataGrid-main': {
        borderRadius: '14px 14px 0 0',
    },
    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#F6F8FC',
        borderBottom: 'none',
        minHeight: '52px !important',
        maxHeight: '52px !important',
        lineHeight: '52px !important',
        borderTopLeftRadius: '14px',
        borderTopRightRadius: '14px',
    },
    '& .MuiDataGrid-columnHeader': {
        backgroundColor: '#F6F8FC',
        color: Colors.PRIMARY_DARK,
        fontSize: '16px',
        letterSpacing: '0.03em',
        fontWeight: 500,
        padding: '12px 16px',
        borderRight: 'none',
        '&:focus, &:focus-within': {
            outline: 'none',
        },
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        color: Colors.NEUTRAL_GRAY,
        fontFamily: 'inherit',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '140%',
        letterSpacing: '0%',
        textAlign: 'left',
    },
    '& .MuiDataGrid-columnSeparator': {
        display: 'none',
    },
    '& .MuiDataGrid-cell': {
        borderBottom: '0 !important',
        borderRight: 'none',
        display: 'flex',
        alignItems: 'center',
        '&:focus, &:focus-within': {
            outline: 'none',
        },
    },
    '& .MuiDataGrid-row': {
        borderBottom: 'none',
        '&:hover': {
            backgroundColor: 'rgba(242, 243, 251, 0.4)',
        },
        '&.non-clickable': {
            cursor: 'default',
            '&:hover': {
                backgroundColor: 'rgba(242, 243, 247, 0.4)',
            },
        },
        '&.clickable': {
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: 'rgba(242, 243, 247, 0.4)',
            },
        },
        '&.Mui-selected': {
            backgroundColor: 'transparent',
            '&:hover': {
                backgroundColor: 'rgba(242, 243, 251, 0.4)',
            },
        },
        '&:not(:last-child)': {
            borderBottom: 'none',
        },
    },
    '& .MuiDataGrid-footerContainer': {
        borderTop: '1px solid #E0E2F1',
        justifyContent: 'center',
        padding: '0',
        borderBottomLeftRadius: '14px',
        borderBottomRightRadius: '14px',
        backgroundColor: 'white',
        minHeight: '60px',
    },
    '& .MuiDataGrid-selectedRowCount': {
        display: 'none',
    },
    // Hide default pagination
    '& .MuiTablePagination-root': {
        display: 'none',
    },
    // Custom pagination styles
    '& .custom-pagination': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        padding: '16px 24px',
        width: '100%',
        backgroundColor: 'white',
        borderBottomLeftRadius: '14px',
        borderBottomRightRadius: '14px',
    },
    '& .pagination-nav-button': {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '8px 12px',
        backgroundColor: 'transparent',
        border: 'none',
        color: '#676E8B',
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer',
        borderRadius: '6px',
        transition: 'all 0.2s ease',

        '&:hover:not(:disabled)': {
            backgroundColor: '#F6F8FC',
            color: '#0E1944',
        },

        '&:disabled': {
            opacity: 0.4,
            cursor: 'default',
        },
    },
    '& .page-circle': {
        width: '36px',
        height: '36px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        border: '1px solid #E0E2F1',
        backgroundColor: 'white',
        color: '#000B19',

        '&:hover:not(:disabled)': {
            backgroundColor: '#F6F8FC',
        },

        '&.active': {
            backgroundColor: '#E0E2F1',
            color: '#0E1944',
            border: 'none',
        },

        '&.ellipsis': {
            cursor: 'default',
            border: 'none',
            backgroundColor: 'transparent',
            color: '#676E8B',
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },

        '&:disabled': {
            cursor: 'default',
        },
    },
}));
